<template>
  <v-dialog
    v-model="$props.model"
    max-width="500px"
    @input="$emit('update:model', $event)"
  >
    <v-card class="rounded-lg">
      <v-card-title class="d-flex justify-center align-center text-h5">
        Konfirmasi Redaksi Penolakan
      </v-card-title>
      <v-card-text class="mt-4">
        <p class="mb-2 font-weight-bold">Konten:</p>
        <v-divider />
        <v-card class="pa-3 mb-3" outlined elevation="0">
          <p class="mb-3">Hi <strong>{{ $props.name }}</strong></p>
          <div class="mb-3">
            <Editor api-key="4paqvfu388didkn8yr5v662i655cn9x3g5w1usf7ucmypuoq" v-model="contentText" :init="editorInit" :disabled="loading" />
          </div>
          <p>
            Jika ada sanggahan atau pertanyaan lebih lanjut, silakan hubungi kami
            melalui <span class="primary--text">Whatsapp</span> atau Email
          </p>
        </v-card>
        <div>
          <v-btn
            color="primary"
            elevation="0"
            x-small
            @click="contentText = defaultText"
            >Reset Default</v-btn
          >
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end align-center">
        <v-btn
          @click="$emit('update:model', false)"
          :disabled="loading"
          elevation="0"
        >
          Kembali
        </v-btn>
        <v-btn
          @click="handleSubmit()"
          :loading="loading"
          color="primary"
          elevation="0"
        >
          Kirim Redaksi Penolakan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  name: "ModalPenolakan",
  components: { Editor },

  props: {
    model: {
      type: Boolean,
      required: true,
    },
    name: String,
    loading: Boolean,
  },
  model: {
    prop: "model",
    event: "update:model",
  },
  data: () => ({
    editorInit: {
      menubar: false,
      toolbar: "undo redo | bold italic underline",
      plugins: "", // kosongkan kalau tak pakai plugin tambahan
      branding: false,
      statusbar: false,
      height: 200,
    },
    defaultText:
      "Mohon maaf sertifikat Anda belum dapat kami kirimkan dikarenakan ada ketidaksesuaian data wajah pada foto KTM dengan hasil tangkapan layar sistem tes atau ada lebih dari satu wajah yang tertangkap kamera atau ada indikasi kecurangan.",
    contentText: "",
  }),
  created() {
    this.contentText = this.defaultText;
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", this.contentText);
    },
  },
};
</script>
